import {
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import TextStatusUnitOfLearning from '../../../../../text/TextStatus';
import TextOverflowLine from '../../../../../text/TextOverflowLine';

const LGDistributionUL = ({ uls = [], loading, currentCurriculum, onMoreInfo, maxLevel, top = 180 }) => {
  let levelsId = [];
  uls?.forEach((ul) => {
    ul?.lcs?.forEach((lc) => {
      const lvls = lc.granularSteps?.filter((step) => step.definition).map((step) => step.levelId);
      levelsId = [...levelsId, ...lvls];
    });
  });

  levelsId = [...new Set(levelsId)];
  const levelsRender = currentCurriculum?.levels
    ?.filter((item) => (loading ? true : levelsId.includes(item._id)))
    .sort((a, b) => a.position - b.position);
  const size = 35;

  const minMarking = currentCurriculum?.marking.find((m) => m.minValue);
  const maxMarking = currentCurriculum?.marking.find((m) => m.maxValue);
  const groupByClassId = uls.reduce((acc, ul) => {
    if (!acc[ul.classId]) {
      acc[ul.classId] = [];
    }
    acc[ul.classId].push(ul);
    return acc;
  }, {});
  const left = 128;

  return (
    <TableContainer className='absolute inset-0' style={{ top }}>
      <Table style={{ width: 'auto' }}>
        <TableHead>
          <TableRow className='sticky top-0px z-12'>
            <TableCell style={{ padding: '1px' }} className='sticky left-0px z-12'>
              <div
                style={{ height: size }}
                className='z-10 max-w-100px min-w-100px px-4 py-2 bg-muted-foreground text-muted text-center h-10  rounded capitalize font-bold'
              >
                <Typography className='font-bold'>Class</Typography>
                <Typography className='text-xs'>Subject</Typography>
              </div>
            </TableCell>
            <TableCell style={{ padding: '1px', left }} className='sticky z-12'>
              <Typography
                style={{ height: size }}
                className=' z-10 max-w-200px min-w-200px px-4 py-2 bg-muted-foreground text-muted text-center h-10 flex items-center justify-center rounded capitalize font-bold'
              >
                Unit of learning
              </Typography>
            </TableCell>
            {levelsRender?.map((item) => {
              let backgroundColor = minMarking?.secondaryColor || 'inherit';
              let color = minMarking?.primaryColor || 'inherit';
              if (maxLevel) {
                if (maxLevel.levelPosition === item.position) {
                  color = maxLevel?.primaryColor;
                  backgroundColor = maxLevel?.secondaryColor || 'inherit';
                } else if (maxLevel.levelPosition < item.position) {
                  color = minMarking?.primaryColor || 'inherit';
                  backgroundColor = minMarking?.secondaryColor || 'inherit';
                } else if (maxLevel.levelPosition > item.position) {
                  color = maxMarking?.primaryColor || 'inherit';
                  backgroundColor = maxMarking?.secondaryColor || 'inherit';
                }
              }
              return (
                <TableCell key={`level-header-${item._id}`} style={{ padding: '1px' }}>
                  <Typography
                    className='size-10 px-2 py-2 bg-muted-foreground text-muted text-center h-10 flex items-center justify-center rounded capitalize font-bold text-lg'
                    style={{
                      width: size,
                      height: size,
                      backgroundColor,
                      color
                    }}
                  >
                    {item.code}
                  </Typography>
                </TableCell>
              );
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          {loading ? (
            Array.from({ length: 12 }).map((_, index) => (
              <TableRow key={`ul-skeleton-${index}`}>
                <TableCell style={{ padding: '1px' }}>
                  <Skeleton variant='rounded' className='w-full h-10 py-2' style={{ height: size }} />
                </TableCell>
                <TableCell style={{ padding: '1px' }}>
                  <Skeleton variant='rounded' className='w-full h-10 py-2' style={{ height: size }} />
                </TableCell>
                {levelsRender?.map((item) => (
                  <TableCell key={`level-skeleton-${item._id}-index-${index}`} style={{ padding: '1px' }}>
                    <Skeleton
                      variant='rounded'
                      className='w-full h-10 px-2 py-2'
                      style={{ width: size, height: size }}
                    />
                  </TableCell>
                ))}
              </TableRow>
            ))
          ) : groupByClassId && Object.keys(groupByClassId).length > 0 ? (
            Object.keys(groupByClassId).map((classId) => {
              const ulsByClass = groupByClassId[classId];
              return ulsByClass.map((ul, index) => (
                <TableRow key={`ul-${ul._id}-index-${index}`}>
                  {index === 0 && (
                    <TableCell
                      style={{ padding: '1px' }}
                      className='sticky left-0px z-10  bg-muted-foreground text-muted max-w-100px min-w-100px'
                      rowSpan={ulsByClass.length}
                    >
                      <div className='px-4 py-2'>
                        <Typography className='font-bold text-center'>{ul?.classCode}</Typography>
                        <TextOverflowLine variant='inherit' className=' text-xs text-center'>
                          {ul?.classSubject}
                        </TextOverflowLine>
                      </div>
                    </TableCell>
                  )}
                  <TableCell
                    style={{ padding: '1px', left }}
                    className='sticky left-0px z-10'
                    onClick={() => onMoreInfo(ul)}
                  >
                    <div
                      className=' px-4 py-2 bg-muted-foreground text-muted text-center rounded gap-2 max-w-200px min-w-200px cursor-pointer'
                      style={{ height: size }}
                    >
                      <TextOverflowLine variant='inherit' className='font-bold text-xs'>
                        <TextStatusUnitOfLearning startDate={ul?.drStartDate} endDate={ul?.drEndDate} />
                        <span className='font-bold  pl-1'>{ul?.drName || ''}</span>
                      </TextOverflowLine>
                    </div>
                  </TableCell>
                  {levelsRender?.map((item) => {
                    let maxLevel = '';
                    let color = minMarking?.secondaryColor || 'inherit';
                    let backgroundColor = minMarking?.primaryColor || 'inherit';
                    let classNameBG = ' bg-muted-foreground';

                    if (ul.maxLevel) {
                      const prom = ul.maxLevel;
                      if (prom.levelPosition === item.position) {
                        backgroundColor = prom?.primaryColor;
                        color = prom?.secondaryColor || 'inherit';
                        maxLevel = item.code;
                      } else if (prom.levelPosition < item.position) {
                        backgroundColor = minMarking?.primaryColor || 'inherit';
                        color = minMarking?.secondaryColor || 'inherit';
                      } else if (prom.levelPosition > item.position) {
                        backgroundColor = maxMarking?.primaryColor || 'inherit';
                        color = maxMarking?.secondaryColor || 'inherit';
                      }
                      if (ul.maxLevelRender) {
                        if (item.position > ul.maxLevelRender.position) {
                          classNameBG = ' bg-lines';
                        }
                      }
                    }
                    return (
                      <TableCell key={`level-header-${item._id}`} style={{ padding: '1px' }}>
                        <Typography
                          className={`size-10 px-2 py-2 text-muted text-center h-10 flex items-center justify-center rounded capitalize font-bold text-lg${classNameBG}`}
                          style={{
                            width: size,
                            height: size,
                            color,
                            backgroundColor
                          }}
                        >
                          {maxLevel}
                        </Typography>
                      </TableCell>
                    );
                  })}
                </TableRow>
              ));
            })
          ) : (
            <TableRow>
              <TableCell style={{ padding: '1px' }} colSpan={2}>
                <Typography
                  component='div'
                  className='flex items-center justify-start px-4 h-14 bg-background text-muted-foreground bg-muted rounded text-sm font-bold'
                >
                  No units of learning found.
                </Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default LGDistributionUL;
